import styled, { css } from 'styled-components';

export const Icon = styled.div<{
  isOpen: boolean;
}>`
  transition-duration: 0.3s;
  position: absolute;
  height: 1px;
  width: 14px;
  top: 15px;
  background-color: ${({ theme }) => theme.palette.white};

  &:before {
    transition-duration: 0.3s;
    position: absolute;
    width: 14px;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.white};
    content: '';
    top: -6px;
  }

  :after {
    transition-duration: 0.3s;
    position: absolute;
    width: 14px;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.white};
    content: '';
    top: 6px;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      background-color: transparent;
      transition-duration: 0.3s;

      &:before {
        transform: rotateZ(45deg) translate(4px, 4px);
      }

      &:after {
        transform: rotateZ(-45deg) translate(4.5px, -4.5px);
      }
    `}
`;

export const HamburgerMenuWrapper = styled.div`
  width: 32px;
  height: 32px;
  padding: 8px;
  position: relative;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.whiteAlpha300};
  transition-duration: 0.3s;

  &:hover {
    cursor: pointer;
  }
`;
